<template>
  <Card class="w-full min-w-96" pt:body="p-2!" pt:content:class="pt-2">
    <template #content>
      <BarChart ref="transactionChart" :info show-pointer @data-point-click="openModal"></BarChart>
    </template>
  </Card>

  <TSDialog label="Transactions" v-model:visible="modalVisible" v-if="modalVisible" icon="chart-bar" size="w-[1100px]!">
    <template #content>
      <div class="flex flex-col">
        <div v-for="transaction in transactions">
          <div class="flex flex-row gap-1 text-surface-500 dark:text-surface-400 font-bold">
            <div class="flex flex-row gap-1">
              <i class="text-xl my-auto pi pi-clock"></i>
              <p class="text-sm my-auto">{{ format(transaction.checkDate, "MM/dd/yyyy") }}</p>
            </div>
            <div class="w-48 ml-5 text-center flex flex-row gap-2 justify-center">
              <Tag class="my-auto w-auto" severity="info">{{ transaction.type }}</Tag>
              <Tag v-if="transaction.voided" class="my-auto w-auto" severity="danger">{{ "VOID" }}</Tag>
            </div>
            <p class="text-sm my-auto w-32 text-center">{{ formatCurrency(transaction.amount) }}</p>
            <p v-visible="transaction.payee && transaction.payee !== ''" class="text-sm my-auto w-72">Payee: {{ transaction.payee }}</p>
            <p v-visible="transaction.processor && transaction.processor !== ''" class="text-sm my-auto w-72">
              Processed By: {{ transaction.processor }}
            </p>
          </div>
          <Divider class="my-2!"></Divider>
        </div>
      </div>
    </template>
  </TSDialog>
</template>

<script setup lang="ts">
import type { DisbursementHistory, Transaction } from "@/types/DisbursementHistory";
import { format } from "date-fns";
import { formatCurrency } from "@/services/Utility";
import type { ECElementEvent } from "echarts";
import type { BarChartInfo } from "@/classes/ChartInfo";

interface Props {
  info: BarChartInfo;
  disbursementHistory: DisbursementHistory[];
}

const props = defineProps<Props>();

const modalVisible = ref(false);
const transactions = ref<Transaction[]>([]);

const transactionChart = ref();

const showLoading = (): void => {
  if (transactionChart.value) {
    transactionChart.value.showLoading();
  }
};

const loadingComplete = (): void => {
  transactionChart.value.loadingComplete();
};

defineExpose({ showLoading, loadingComplete });

const openModal = (params: ECElementEvent): void => {
  transactions.value = props.disbursementHistory[params.dataIndex].transactions;
  modalVisible.value = true;
};
</script>
